import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type SortPlacement = 'filter_bar' | 'sort_menu';

// v2 adds placement. The bump is what lets a consumer tell "this client could not
// have sent it" from "it should be here and isn't", and it is what keeps CAPI able
// to accept in-flight v1 clients while holding v2 ones to the field.
const SORT_SCHEMA_VERSION = 2;

export type SortTargetProperties = {
  filters?: { key: string; value: string }[];
  placement: SortPlacement;
  selected_sort_key: string;
  sort_key: string;
};

type EventData = {
  filters?: { key: string; value: string }[];
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement: SortPlacement;
  selectedSortKey: string;
  sortKey: string;
};

class SortInteractionEvent extends InteractionEvent<
  EventData,
  SortTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'sort';
  }

  protected get schemaVersion(): number {
    return SORT_SCHEMA_VERSION;
  }

  protected getTargetProperties(): SortTargetProperties {
    return {
      filters: this.data.filters,
      placement: this.data.placement,
      selected_sort_key: this.data.selectedSortKey,
      sort_key: this.data.sortKey
    };
  }
}

export default SortInteractionEvent;
